import type { Movie } from "@/lib/types";

interface PlotSectionProps {
  movie: Movie;
}

export default function PlotSection({ movie }: PlotSectionProps) {
  return (
    <section
      id="plot"
      className="mt-10 md:mt-12 rounded-lg border border-background-200/70 bg-background-100/50 p-5 md:p-7 scroll-mt-24"
    >
      <div className="flex items-center gap-2.5 mb-5">
        <span className="w-1 h-5 rounded-full bg-accent-500"></span>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
          剧情简介与解析
        </h2>
      </div>

      <div className="space-y-4 text-sm md:text-[15px] leading-8 text-foreground-400">
        {movie.plot.map((paragraph, index) => (
          <p key={index} className={index === 0 ? "text-foreground-300" : undefined}>
            {paragraph}
          </p>
        ))}
      </div>

      <div className="mt-7 pt-5 border-t border-background-200/60">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs text-foreground-600 mr-1">相关标签</span>
          {movie.tags.map((tag) => (
            <span
              key={tag}
              className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-[11px]"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>

      <p className="mt-5 text-[11px] leading-relaxed text-foreground-600">
        以上内容为本站编辑撰写的剧情介绍与评论，仅用于影视讨论交流。本站不提供任何在线播放、下载或资源跳转服务。
      </p>
    </section>
  );
}